import { Injectable, NgZone } from "@angular/core";

/**
 * Monitorea la actividad del usuario en la pestaña.
 * No cierra sesión: solo expone cuánto tiempo ha pasado desde la última
 * interacción, para que otros servicios decidan qué hacer.
 */
@Injectable({ providedIn: "root" })
export class InactivityService {
    private readonly eventosUsuario = [
        "mousemove",
        "keydown",
        "scroll",
        "touchstart",
        "click",
    ];

    private ultimaActividadMs: number = Date.now();
    private watching = false;
    private handler = this.registrarActividad.bind(this);

    constructor(private ngZone: NgZone) {}

    startWatching(): void {
        if (this.watching) return;
        this.watching = true;
        this.ultimaActividadMs = Date.now();

        this.ngZone.runOutsideAngular(() => {
            this.eventosUsuario.forEach((event) => {
                window.addEventListener(event, this.handler, { passive: true });
            });
        });
    }

    eliminarEventos(): void {
        if (!this.watching) return;
        this.watching = false;
        this.eventosUsuario.forEach((event) => {
            window.removeEventListener(event, this.handler);
        });
    }

    msDesdeUltimaActividad(): number {
        return Date.now() - this.ultimaActividadMs;
    }

    resetear(): void {
        this.ultimaActividadMs = Date.now();
    }

    private registrarActividad(): void {
        this.ultimaActividadMs = Date.now();
    }
}
